/*
 * Accordion
 */
if (!customElements.get("accordion-item")) {
  customElements.define(
    "accordion-item",
    class AccordionItem extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          toggler: ".js-accordion-toggler",
          content: ".js-accordion-content",
        };

        this.classes = {
          isExpanded: "is-expanded",
        };

        this.accordion = $(this);
        this.toggler = this.accordion.find(this.selectors.toggler);
        this.content = this.accordion.find(this.selectors.content);

        this.init();
      }

      init() {
        this.toggler.on("click", (event) => {
          event.preventDefault();

          this.accordion.toggleClass(this.classes.isExpanded);

          this.content.stop().slideToggle();

          // this.accordion.siblings().removeClass(this.classes.isExpanded).find(this.selectors.content).stop().slideUp();
        });
      }
    }
  );
}
